<template>
  <simple-select :options="metroList" :value="value" @input="forwardEvent">
    <template v-slot>{{ displayName }}</template>
  </simple-select>
</template>

<script>
import { SimpleSelect } from 'kanzler.components';

export default {
  props: {
    metros: {
      type: Array,
      default: () => []
    },
    value: {
      type: String,
      default: ''
    }
  },
  computed: {
    metroList() {
      return this.metros.reduce((keyValueObject, item) => {
          keyValueObject.set(item, item);
          return keyValueObject;
      }, new Map([["", BX.message('KZ_SHOPS_SELECT_ALL')],]));
    },
    displayName() {
      return this.value === '' ? BX.message('KZ_SHOPS_SELECT_METRO') : this.value;
    }
  },
  components: {
    'simple-select': SimpleSelect
  },
  methods: {
    forwardEvent(value) {
      this.$emit('input', value);
    }
  }
}
</script>
